import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Layout from '../../../components/UI/Layout/Layout';
import WireDataItems from '../../../components/WireDataComponents/WireDataItems/WireDataItems';
import LocalizedStrings from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

class WireSelectorPage extends Component {
  goBackHandler = () => {
    this.props.history.push('/');
  };

  render() {
    const {
      country,
      language,
      selectedUSA,
      selectedCanadaEN,
      selectedCanadaFR
    } = this.props;
    return (
      <Layout
        title={LocalizedStrings[language].wireData}
        clicked={this.goBackHandler}
        country={country}
        language={language}
        selectedCanadaEN={selectedCanadaEN}
        selectedCanadaFR={selectedCanadaFR}
        selectedUSA={selectedUSA}
      >
        <WireDataItems country={country} language={language} />
      </Layout>
    );
  }
}

WireSelectorPage.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  selectedUSA: PropTypes.func,
  selectedCanadaEN: PropTypes.func,
  selectedCanadaFR: PropTypes.func
};

export default withRouter(WireSelectorPage);
